// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"LinkButton_linkButton__2Z_2m"};